import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';

import { MegaMenuNavItem } from './types';

const {
  PRIMARY: { ALBUMS },
} = NAV_DATA;

const getAlbums = (): MegaMenuNavItem => {
  return {
    id: ALBUMS,
    title: 'Albums',
    path: '/wedding-albums/shop',
    parent: 'Albums',
    callToAction: {
      path: '/wedding-albums/shop',
      title: 'Get Started',
      items: [
        'Effortless customization with free Album Wizard',
        'Premium printing quality at printer paper prices',
        'Luxe paper, foils, linens, leathers, and more',
      ],
    },
    userActionsLinks: [
      {
        title: 'Your Drafts',
        path: '/wedding-albums/drafts',
      },
      {
        title: 'Your Orders',
        path: '/wedding-albums/orders',
      },
    ],
    children: [
      {
        headline: 'Get Advice and Inspo',
        borderLeft: true,
        children: [
          {
            title: '12 Unique Wedding Album Ideas',
            path: '/expert-advice/12-unique-wedding-album-ideas',
          },
          {
            title: 'How to Design the Ultimate Wedding Photo Album',
            path: '/expert-advice/how-to-design-the-ultimate-wedding-photo-book',
          },
          {
            title: 'What to Do With Your Wedding Photos',
            path: '/expert-advice/what-to-do-with-your-wedding-photos',
          },
          {
            title: 'How to Store Your Wedding Photos',
            path: '/expert-advice/how-to-store-your-wedding-photos',
          },
        ],
      },
    ],
  };
};

export default getAlbums;
